import React from 'react';

const StrategyBuilder = ({ 
  selectedCategory, 
  setSelectedCategory,
  strategies,
  categories,
  formData,
  handleInputChange,
  addToEntryConditions,
  addToExitConditions,
  theme,
  isDarkTheme
}) => {
  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    border: `1px solid ${theme?.border || '#ddd'}`,
    borderRadius: '4px',
    fontSize: '14px',
    fontFamily: 'inherit',
    backgroundColor: theme?.cardBg || 'white',
    color: theme?.textPrimary || '#333'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '13px',
    color: theme?.textSecondary || '#666',
    marginBottom: '8px',
    fontWeight: 500
  };

  return (
    <div>
      {/* Entry and Exit Conditions */}
      <div style={{ marginBottom: '30px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          {/* Entry Conditions */}
          <div>
            <label style={labelStyle}>📥 Entry Conditions</label>
            <textarea
              name="entryConditions"
              value={formData.entryConditions}
              onChange={handleInputChange}
              style={{
                ...inputStyle,
                minHeight: '120px',
                resize: 'vertical',
                fontFamily: '"Courier New", monospace',
                fontSize: '13px',
                lineHeight: '1.5'
              }}
              placeholder="Define when to enter trades..."
            />
          </div>
          
          {/* Exit Conditions */}
          <div>
            <label style={labelStyle}>📤 Exit Conditions</label>
            <textarea
              name="exitConditions"
              value={formData.exitConditions}
              onChange={handleInputChange}
              style={{
                ...inputStyle,
                minHeight: '120px',
                resize: 'vertical',
                fontFamily: '"Courier New", monospace',
                fontSize: '13px',
                lineHeight: '1.5'
              }}
              placeholder="Define when to exit trades..."
            />
          </div>
        </div>
        
        <small style={{ 
          display: 'block', 
          marginTop: '12px', 
          color: theme?.textSecondary || '#666', 
          fontSize: '12px',
          padding: '10px',
          backgroundColor: isDarkTheme ? '#333' : '#f8f9fa',
          borderRadius: '4px',
          lineHeight: '1.6'
        }}>
          <strong>💡 Tip:</strong> Use the "Strategy Samples" tab to find pre-built conditions. Combine with <code>and</code>/<code>or</code> operators.
          <br />
          <strong>Example:</strong> <code>CLOSE &gt; SMA(20) and RSI(14) &lt; 70</code>
        </small>
      </div>

      {/* Stop Loss and Target Settings */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 600, 
          marginBottom: '15px', 
          color: theme?.textPrimary || '#333',
          borderBottom: `2px solid ${theme?.border || '#e0e0e0'}`,
          paddingBottom: '8px'
        }}>
          🎯 Risk Management
        </h3>
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
          <div>
            <label style={labelStyle}>🛑 Stop Loss (%)</label>
            <input
              type="number"
              name="stopLoss"
              value={formData.stopLoss || ''}
              onChange={handleInputChange}
              style={inputStyle}
              step="0.1"
              min="0"
              max="50"
              placeholder="e.g., 5.0"
            />
          </div>
          
          <div>
            <label style={labelStyle}>🎯 Target (%)</label>
            <input
              type="number"
              name="target"
              value={formData.target || ''}
              onChange={handleInputChange}
              style={inputStyle}
              step="0.1"
              min="0"
              max="100"
              placeholder="e.g., 10.0"
            />
          </div>
          
          <div>
            <label style={labelStyle}>📈 Trailing Stop (%)</label>
            <input
              type="number"
              name="trailingStop"
              value={formData.trailingStop || ''}
              onChange={handleInputChange}
              style={inputStyle}
              step="0.1"
              min="0"
              max="50"
              placeholder="e.g., 3.0"
            />
          </div>
        </div>
        
        <small style={{ 
          display: 'block', 
          marginTop: '10px', 
          color: theme?.textSecondary || '#666', 
          fontSize: '11px',
          padding: '8px',
          backgroundColor: isDarkTheme ? '#1a2a3a' : '#f0f7ff',
          borderRadius: '4px',
          lineHeight: '1.5'
        }}>
          <strong>ℹ️ Risk Management:</strong> Stop Loss limits losses, Target locks in profits, Trailing Stop follows price movements.
        </small>
      </div>
    </div>
  );
};

export default StrategyBuilder;